import { render, staticRenderFns } from "./miaoshu-wufenzu-fenleii.vue?vue&type=template&id=9bd78728&"
import script from "./miaoshu-wufenzu-fenleii.vue?vue&type=script&lang=ts&"
export * from "./miaoshu-wufenzu-fenleii.vue?vue&type=script&lang=ts&"
import style0 from "./miaoshu-wufenzu-fenleii.vue?vue&type=style&index=0&id=9bd78728&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports